<template>
    <div>
        <div class="white-box">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div v-else>
                    <h4 class="mb-2.5 md:mt-1 md:pb-4 border-b border-solid">
                        請選擇欲轉入之投資標的與配置比例
                    </h4>
                    <BankFundForm
                        v-model:validInput="validInput"
                        v-model:subtotal="subtotal"
                        :data="userData"
                        :bankList="bankList"
                        :fundBankList="fundBankList"
                        :auto-add-row="true"
                        :has-title="true"
                        @getValidResult="getValidResult"
                    />
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #left>
                <button
                    class="btn-text arrow-l"
                    @click="goBack"
                >
                    修改轉出標的
                </button>
            </template>
            <template #top>
                <div class="text-xs py-1">
                    剩餘可分配比例：
                </div>
                <div class="text-base xs:text-lg py-1">
                    {{ subtotal }}%
                </div>
            </template>
            <template #center>
                <div class="text-base py-2.5">
                    剩餘可分配比例： {{ subtotal }}%
                </div>
            </template>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import routeName from '@/router/constant.js';
import Loading from '@/components/Loading.vue';
import { getFundBankInfoA6, submitA6,fundCodeInfo } from '@/apis/A6';
import BankFundForm from '@/components/template/bankFund/BankFundForm.vue';
// import dialogContnet from '@/json/dialogContent.js';
import Skeletons from './Skeletons.vue';

export default {
    name: 'AllocationRatio',
    components: {
        Bottombar,
        Loading,
        BankFundForm,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const userData = ref([]);
        const bankList = ref([]);
        const fundBankList = ref([]);
        const isButtonDisabled = ref(false);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const isGettingData = ref(false);
        const validInput = ref(false);
        const subtotal = ref(0);
        const { code } = route.meta;
        const transformOutList = computed(() => {
            const vuexData = store.state.services.changeItemsResult;
            return vuexData[`${code}EXPORT`]?.transformOutList;
        });
        const result = computed(() => store.state.services?.changeItemsResult[code]);

        /** 取得頁面資料 */
        const getData = () => {
            isGettingData.value = true;
            /** 選單資料 */
            getFundBankInfoA6().then(res => {
                bankList.value = res.data.bankList.map(i => {
                    i.value = i.bankNo;
                    return i;
                });
                fundBankList.value = res.data.fundBankList.map(i => {
                    i.value = i.fundCode;
                    i.label = `${i.fundCode} ${i.fundName} (${i.fundTypeCH})`;
                    return i;
                });
            }).finally(() => {
                isGettingData.value = false;
            });
        };

        const modalShow = (params,vl) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                        if(vl())vl();
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        if (!result.value) {
            getData();
        } else {
            const { storeUserData, storeBank, storeFundBank } = result.value;
            const duplicateFundCode = [];
            storeUserData.forEach(i => {
                const index = transformOutList.value.findIndex(j => j.fundCode === i.fundCode);
                // 沒有重複就塞給userData，有重複FundCode就把基金代號塞到duplicateFundCode
                index === -1 ? userData.value.push(i) : duplicateFundCode.push(i.fundCode);
            });
            // 有重複FundCode就show modal
            if (duplicateFundCode.length !== 0) {
                // 轉出與轉入同一基金衝突燈箱
                const str = duplicateFundCode.join('、');
                const params = {
                    title: '提示',
                    content: `基金代號［${str}］不可同時轉入與轉出。`,
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: false,
                };
                modalShow(params);
            }
            bankList.value = storeBank;
            fundBankList.value = storeFundBank;
        }

        /** 下一步 */
        const saveAndgoNext = () => {
            validInput.value = true;
        };
        const getValidResult = (hasFormError) => {
            if (!hasFormError) {
                submitData();
            }
        };
        /** 送出資料 */
       
        const submitData = () => {
            const returnData = {};
            returnData.transformInList = userData.value.map(i => {
                return {
                    fundCode: i.fundCode,
                    transferPercent: i.percent,
                };
            });
            returnData.transformOutList = transformOutList.value;

            const fundCode = [...returnData.transformInList.map(item => ({
                fundCode : item.fundCode,
                kind: 1,
            })),
            ...returnData.transformOutList.map(item => ({
                fundCode : item.fundCode,
                kind: 0,
            }))
        ];
            const paload = { fundCodeOutList : fundCode}
            fundCodeInfo(paload).then(res => {
                const params = {
                    title: '提示',
                    // content: `基金代號［${str}］不可同時轉入與轉出。`,
                    content : `${res.data.fundCodeMsg}`.replace(/\n/g,"<br>"),
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: false,
                }
                const hasFundCodeMsg = res.data.fundCodeMsg && res.data.fundCodeMsg.trim() !== "";
                if(hasFundCodeMsg){
                    modalShow(params,callA6);
                }else{
                    callA6();
                }
                
            });
            const callA6 = () =>{
            submitA6(returnData).then(res => {
                isSubmitOk.value = true;
                const storeData = {
                    storeUserData: userData.value,
                    storeBank: bankList.value,
                    storeFundBank: fundBankList.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value: storeData });
            }).finally(() => {
                isLoading.value = false;
            });
        }
        };
        
        
       


        /** 上一步 */
        const goBack = () => {
            router.push({ name: routeName.TRANSFORM_EXPORT });
        };
        // 轉出金額總和
        const allocatableSum = computed(() => { return '100%'; });

        return {
            fundBankList,
            allocatableSum,
            subtotal,
            isSubmitOk,
            userData,
            bankList,
            goBack,
            saveAndgoNext,
            isButtonDisabled,
            isLoading,
            isGettingData,
            getValidResult,
            validInput
        };
    }
};
</script>
